import React, {
  forwardRef,
  useState,
  useRef,
  useCallback,
  useEffect,
} from "react";
import { useDetectOutsideClick } from "./useDetectOutsideClick";
import classNames from "classnames";
import Lightbox from "react-image-lightbox";
import axios from "axios";
import {
  trimFileName,
  formatedMentionsToHtml,
  linkify,
  formatedMentions,
  isValidURL,
} from "../../utils/formatters";
import { withStyles } from "@material-ui/core/styles";
import { Image, Videocam, InsertDriveFile } from "@material-ui/icons";

import ReplyIcon from "@material-ui/icons/Reply";
import MoreVertRoundedIcon from "@material-ui/icons/MoreVertRounded";
import { maxTextLength } from "../../utils/formatters.js";
import "react-dropdown/style.css";
import "react-image-lightbox/style.css";
import "./Message.scss";
import { Avatar } from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import Edit from "../../assets/Edit.png";
import Delete from "../../assets/Delete.png";
import Anexo from "../../assets/Anexo.png";
import AlertDialog from "../modal";
import URLPreview from "../URLPreview";
import app from "../../services/base.js";
import { generateUniqueFirestoreId } from "../../utils/math";

const styles = () => ({
  colorDefault: {
    backgroundColor: "#51A6FF",
    borderRadius: " 100%",
    gridRow: "span 2",
    width: 48,
    height: 48,
    cursor: "pointer",
  },
  primary: {
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: 14,
    color: "#303030",
  },
  secondary: {
    color: "#303030",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: 14,
  },
});
const Message = (props, ref) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showReplyIcon, setShowReplyIcon] = useState(false);
  const dropdownRef = useRef(null);
  const [isActive, setIsActive] = useDetectOutsideClick(dropdownRef, false);
  const showDropDown = () => setIsActive(!isActive);
  const [positionMenu, setPositionMenu] = useState({ top: 0, left: 0 });
  const [extraShowIcons, setExtraShowIcons] = useState(false);
  const [open, setOpen] = useState(false);
  const [modalAction, setModalAction] = useState({});

  const messageClass = classNames("message-row", {
    "you-message": props.isMyMessage,
    "other-message": !props.isMyMessage,
  });
  const messageContent = classNames("message-content", {
    private: props.chatType !== "GroupChat",
  });

  function renderAttachment(attachment) {
    if (attachment.type.includes("image")) {
      return (
        <div className="render-attachment">
          <Image /> <span className={props.classes.secondary}> Imagem</span>
        </div>
      );
    } else if (attachment.type.includes("video")) {
      return (
        <div className="render-attachment">
          <Videocam /> <span className={props.classes.secondary}> Vídeo</span>
        </div>
      );
    } else {
      return (
        <div className="render-attachment">
          <InsertDriveFile />
          <span className={props.classes.secondary}> Documento</span>
        </div>
      );
    }
  }
  function renderAttachmentFiles(message) {
    let attachment = message.attachment;
    if (attachment.contentType.includes("image")) {
      return (
        <>
          <img
            onClick={() => setIsOpen(true)}
            src={attachment.remoteUrl}
            alt="Imagem enviada"
          />
          {isOpen && (
            <Lightbox
              mainSrc={attachment.remoteUrl}
              onCloseRequest={() => setIsOpen(false)}
            />
          )}
        </>
      );
    } else if (attachment.contentType.includes("video")) {
      return (
        <video controls>
          <source src={attachment.remoteUrl} />
          Oops! Seu navegador não tem suporte a vídeos!
        </video>
      );
    } else if (attachment.contentType.includes("docs")) {
      if (attachment.type.includes("pdf")) {
        return (
          <object data={attachment.remoteUrl}>
            Oops! Seu navegador não tem suporte a visualização de documentos!
          </object>
        );
      }

      return (
        <div style={{ margin: 10 }}>
          <div className="render-attachment-box">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                margin: 10,
                color: "#fff",
              }}
            >
              {renderAttachment(attachment)}
              <a href="#" onClick={() => download(message)}>
                {trimFileName(attachment.name, 15)}
              </a>
            </div>
          </div>
        </div>
      );
    }
  }
  function messageReplied(message) {
    const {
      reply: { replyTo, replyMsg, attachment },
    } = message;

    return (
      <div
        className="message-replied"
        onClick={() => {
          props.handleClick();
        }}
      >
        <div className="message-replied-bar" />
        <div className="message-replied-box">
          {props.chatType === "GroupChat" && (
            <span className="message-replied-content message-replied-username">
              {replyTo}
            </span>
          )}
          {replyMsg.trim().length > 0 && (
            <span className="message-replied-content">
              {maxTextLength(formatedMentions(replyMsg), 100)}
            </span>
          )}
          <div style={{ paddingLeft: 10 }}>
            {attachment && renderAttachment(attachment)}
          </div>
        </div>
      </div>
    );
  }
  function renderURLPreview(text) {
    if (isValidURL(text)) {
      return <URLPreview link={text} />;
    } else {
      return null;
    }
  }
  function _pinnedMessage(message) {
    props.pinMessage(message);
    setOpen(false);
  }
  const download = (message) => {
    axios({
      method: "get",
      url: message.attachment.remoteUrl,
      responseType: "blob",
      "Content-Type": `application/${message.attachment.contentType}`,
    })
      .then(function (response) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", message.attachment.name);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch(function (err) {
        console.error(err);
      });
  };
  function Menu() {
    const {
      editMessage,
      removeMessage,
      pinnedMessage,
      isMyMessage,
      message,
      chatType,
      moderator,
      currentUserId,
      isManager,
    } = props;
    let isPermission =
      moderator.find((elem) => elem === currentUserId) || isManager;
    if (!isMyMessage && !isPermission && !isManager && !message.attachment) {
      return;
    }
    return (
      <div>
        <nav
          ref={dropdownRef}
          className={`menu ${isActive ? "active" : "inactive"}`}
          style={{ top: positionMenu.top + 20, left: positionMenu.left }}
        >
          <ul style={{ display: "flex", flexDirection: "column" }}>
            {isMyMessage && (
              <>
                <li onClick={() => editMessage(message)}>
                  <img src={Edit} style={{ width: "30px", height: "30px" }} />
                  <a>Editar mensagem</a>
                </li>
                <li
                  onClick={() => {
                    setModalAction({
                      actionConfirmation: () => {
                        removeMessage(message);
                      },
                      title: "Tem certeza que deseja deletar essa mensagem?",
                      legend:
                        "Ao confirmar, essa mensagem será apagada para todos.",
                      buttonConfirmation: true,
                      actionCancel: () => setOpen(false),
                    });
                    setOpen(true);
                  }}
                >
                  <img
                    src={Delete}
                    style={{
                      width: "20px",
                      height: "20px",
                      marginTop: "6px",
                      marginRight: "8px",
                    }}
                  />
                  <a>Excluir mensagem</a>
                </li>
              </>
            )}
            {isPermission && chatType === "GroupChat" && (
              <>
                <li
                  onClick={() => {
                    setModalAction({
                      actionConfirmation: () => {
                        _pinnedMessage(message);
                      },
                      title: "Tem certeza que deseja fixar essa mensagem?",
                      legend:
                        "Ao confirmar, essa mensagem será fixada para todos.",
                      buttonConfirmation: true,
                      actionCancel: () => setOpen(false),
                    });
                    setOpen(true);
                  }}
                >
                  <img
                    src={Anexo}
                    style={{
                      width: "20px",
                      height: "20px",
                      marginTop: "6px",
                      marginRight: "8px",
                    }}
                  />
                  <a href="#">Fixar mensagem</a>
                </li>
                {!isMyMessage && (
                  <li
                    onClick={() => {
                      setModalAction({
                        actionConfirmation: () => {
                          _pinnedMessage(message);
                        },
                        title: "Tem certeza que deseja fixar essa mensagem?",
                        legend:
                          "Ao confirmar, essa mensagem será fixada para todos.",
                        buttonConfirmation: true,
                        actionCancel: () => setOpen(false),
                      });
                      setOpen(true);
                    }}
                  >
                    <img
                      src={Delete}
                      style={{
                        width: "20px",
                        height: "20px",
                        marginTop: "6px",
                        marginRight: "8px",
                      }}
                    />
                    <a>Excluir mensagem</a>
                  </li>
                )}
              </>
            )}
            {message.attachment && (
              <li
                onClick={() => {
                  download(message);
                }}
              >
                <GetAppIcon
                  style={{
                    color: "#071FC1",
                    width: "20px",
                    height: "20px",
                    marginTop: "6px",
                    marginRight: "8px",
                  }}
                />
                <a rel="noopener noreferrer">Baixar</a>
              </li>
            )}
          </ul>
        </nav>
      </div>
    );
  }
  function Options() {
    const {
      moderator,
      isMyMessage,
      currentUserId,
      isManager,
      chatType,
      message,
    } = props;
    let isPermission =
      moderator.find((elem) => elem === currentUserId) || isManager;
    return (
      <>
        {showReplyIcon && (
          <>
            <div className={`${isMyMessage ? "row" : "row-reverse"} icon`}>
              {isMyMessage ||
              (isPermission && chatType === "GroupChat") ||
              message.attachment ? (
                <div>
                  <div
                    className="circle-icon"
                    onClick={(e) => {
                      printMousePos(e);
                      showDropDown();
                    }}
                  >
                    <MoreVertRoundedIcon
                      style={{ color: "#071FC1" }}
                      fontSize="large"
                    />
                  </div>
                  {Menu()}
                </div>
              ) : null}
              <div
                onClick={() => props.displayReplyView(true, props.message)}
                className="circle-icon"
              >
                <ReplyIcon style={{ color: "#071FC1" }} fontSize="large" />
              </div>
            </div>
          </>
        )}
      </>
    );
  }
  function printMousePos(e) {
    let position = { left: e.clientX - 20, top: e.clientY };
    if (e.clientY > 500) {
      let left =
        props.currentUserId === props.message.targetUserId
          ? e.clientX -
            document.getElementsByClassName("menu")[0].getBoundingClientRect()
              .width
          : e.clientX;
      let top =
        e.clientY -
        document.getElementsByClassName("menu")[0].getBoundingClientRect()
          .height -
        38;
      position = { left, marginTop: "-1%", top };
    }
    setPositionMenu(position);
  }

  return (
    <div className={messageClass} ref={ref}>
      <div
        className={messageContent}
        onMouseOver={() => setExtraShowIcons(true)}
        onMouseLeave={() => {
          setExtraShowIcons(false);
          setShowReplyIcon(false);
          setIsActive(false);
        }}
      >
        {/* FOTO DO USUÁRIO */}
        {!props.isMyMessage &&
          !props.message.system &&
          props.chatType === "GroupChat" && (
            <Avatar
              onClick={() => props.sendMessage(props.message.user._id)}
              className={props.classes.colorDefault}
              src={props.message.user.photoURL}
            />
          )}
        {/* MENSAGENS DO SISTEMA */}
        {props.message.system && <Avatar></Avatar>}
        <div>
          <div className={`${props.isMyMessage ? "row" : "row-reverse"}`}>
            {/* OPÇÕES DA MENSAGEM */}
            {Options()}
            <div
              onMouseOver={() => setShowReplyIcon(true)}
              onMouseLeave={() => {
                if (extraShowIcons) setShowReplyIcon(true);
                else {
                  setShowReplyIcon(false);
                  setIsActive(false);
                }
              }}
              className="message-box"
            >
              <div>
                {!props.message.system ? (
                  !props.isMyMessage ? (
                    <div className="message-content">
                      {props.chatType === "GroupChat" && (
                        <span
                          className="username"
                          onClick={() =>
                            props.sendMessage(props.message.user._id)
                          }
                        >
                          {`${props.message.user.firstName} ${props.message.user.lastName}`}
                        </span>
                      )}
                      {/* MENSAGEM REPLY */}
                      {props.message.isReply && messageReplied(props.message)}
                      {props.message.attachment &&
                        renderAttachmentFiles(props.message)}
                      {renderURLPreview(props.message.text)}
                      <span
                        dangerouslySetInnerHTML={{
                          __html: linkify(
                            formatedMentionsToHtml(
                              props.message.text,
                              props.currentUserId
                            )
                          ),
                        }}
                      />
                    </div>
                  ) : (
                    <div className="message-content">
                      {/* MENSAGEM REPLY */}
                      {props.message.isReply && messageReplied(props.message)}
                      {props.message.attachment &&
                        renderAttachmentFiles(props.message)}
                      {renderURLPreview(props.message.text)}
                      <span
                        dangerouslySetInnerHTML={{
                          __html: linkify(
                            formatedMentionsToHtml(
                              props.message.text,
                              props.currentUserId
                            )
                          ),
                        }}
                      />
                    </div>
                  )
                ) : null}
              </div>
            </div>
          </div>
          <div
            className="message-time"
            style={{
              display: "flex",
              justifyContent: `${
                props.isMyMessage ? "flex-end" : "flex-start"
              }`,
            }}
          >
            {props.message.createdAt}
          </div>
        </div>
      </div>
      <AlertDialog open={open} {...modalAction} />
    </div>
  );
};

export default withStyles(styles)(forwardRef(Message));
